var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u8868\\u683C\\u7EC4\\u4EF6",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1,
    transform: "translate(-1375.000000, -197.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "add",
    transform: "translate(1373.000000, 195.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00399325,2 C7.39823178,2 7.7199931,2.24936928 7.7199931,2.5631249 L7.719,6.287 L11.4366856,6.2879934 C11.7505263,6.2879934 11.9998105,6.60975472 11.9998105,7.00399325 C12.0079865,7.40623749 11.7505263,7.7199931 11.4448616,7.7199931 L7.719,7.719 L7.7199931,11.4366856 C7.7199931,11.7505263 7.39823178,11.9998105 7.00399325,11.9998105 C6.60174902,12.0079865 6.2879934,11.7505263 6.2879934,11.4448616 L6.287,7.719 L2.5631249,7.7199931 C2.24936928,7.7199931 2,7.39823178 2,7.00399325 C2,6.60983989 2.24936928,6.2879934 2.5631249,6.2879934 L6.287,6.287 L6.2879934,2.5631249 C6.2879934,2.24936928 6.60975472,2 7.00399325,2 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "currentColor"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.8b2e7454.svg";
export { ForwardRef as ReactComponent };